// extracted by mini-css-extract-plugin
module.exports = {"card-image__image-grid":"card-image_card-image__image-grid__7kXYJ","card-image__image-item":"card-image_card-image__image-item__frE81"};